import type { FaireProductEntity } from "../../entity_types/product";

export const p_kddphg7m4m: FaireProductEntity = {
  token: "p_kddphg7m4m",
  type: "product",
  name: "Hand Crème - Incendier",
  brandToken: "b_phyk4zwbt3",
  brandName: "Mienne",
  imageUrl:
    "https://cdn.faire.com/fastly/4daf3e2a9235f27823ab244828d52ae0fa72e862a21cb2199b9d6744b4a3cfdd.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a2db15d9aff5d0d8852fe33b82b3a2da1688e4e4110475d300249da71d75cc29.jpeg",
    "https://cdn.faire.com/fastly/6288a8a651f12949ab6cac892beff8fff569d3eac7d8d7575e82be7687858c19.jpeg",
    "https://cdn.faire.com/fastly/8f82d731cfcab97dc3dc722cda7a42bc0aeaf2b1bb3fe112d3e497311b157dc7.jpeg",
    "https://cdn.faire.com/fastly/db4b591266c00bf9dd8493c7ec0234aca6008528424bcc2bf21348b9e0976edd.jpeg",
  ],
  priceDollars: 12.25,
  description:
    "A cashmere-soft hand cream that deeply hydrates, smooths, and rejuvenates for lasting softness. Botanical oils and butters blend with Peptides, Niacinamide, Ceramides, and Multi-Weight Hyaluronic Acid to refine and restore, while mood-shifting adaptogens and two signature scents heighten connection through the senses.\n",
  tags: [],
  msrpDollars: 35,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-24T21:32:34.662Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
